
/* injects from baggage-loader */

'use strict';

export default class AddBankAccountController {

	constructor($log, $scope, $timeout, $document, stripe, Parse, Alerts) {
		'ngInject';

		this.heading = 'Add New Bank Account';

		this.$log = $log;
		this.$scope = $scope;
		this.$document = $document;
		this.$timeout = $timeout;
		this.stripe = stripe;
		this.Parse = Parse;
		this.Alerts = Alerts;

		// Types of account that can be linked
		this.accountTypes = [{
			type: 'individual',
			code: 'individual-checking',
			name: 'Personal Checking'
		}, {
			type: 'individual',
			code: 'individual-savings',
			name: 'Personal Savings'
		}, {
			type: 'company',
			code: 'company-checking',
			name: 'Company Checking'
		}, {
			type: 'company',
			code: 'company-savings',
			name: 'Company Savings'
		}];

		// Hold account form
		this.account = {};

		this.test_data = {
			first_name: 'Test',
			last_name: 'Person',
			routing_number: '110000000',
			account_number: '000123456789',
			account_number_verify: '000123456789',
			type: this.accountTypes[0]
		};

		// this.account = this.test_data;

		this.linkingAccount = false;

	}

	$onInit() {

	}

	/**
	 * Returns true when the form is completed
	 */
	validateForm() {

	}

	scrollToAlert() {
		this.$timeout(() => {
			let element = angular.element(document.getElementById('payment-settings'));
			this.$document.scrollToElementAnimated(element, 80);
		}, 100);
	}


	close() {
		this.$scope.$emit('accountSettings.closeAddBankAccountForm');
	}

	/**
	 * Creates a new bank account linked to the current user
	 */
	save() {

		// Clear local alerts
		this.Alerts.clearLocal();

		this.linkingAccount = true;

		/**
		 * stripe.bankAccount methods
		 * - createToken
		 * - validateRoutingNumber
		 * - validateAccountNumber
		 */

		// Create a source token for the new bank account
		return this.stripe.bankAccount.createToken({
			country: 'US',
			currency: 'usd',
			routing_number: this.account.routing_number,
			account_number: this.account.account_number,
			account_holder_name: [this.account.first_name, this.account.last_name].join(' '),
			// Grab the "type" from "account.type", this double is NOT a typo
			account_holder_type: this.account.type.type,
		}).then(result => {

			/* Returns 
					result.bank_account		<- Bank account object
					result.id		<- Source token
			*/
			this.$log.log(result);

			// Add the bank account to the users stripe account
			return this.Parse.Cloud.run('linkBankAccount', {
				source: result.id,
				metadata: {
					type: this.account.type.name
				}
			})
				.then(source_account => {
					this.$log.log(source_account);

					this.linkingAccount = false;

					// Send the account back to the payments page
					this.$scope.$emit('accountSettings.newBankAccount', source_account);

					// Display local alert
					this.Alerts.setLocal({
						msg: 'Account linked successfully',
						type: 'success'
					});

					this.scrollToAlert();

				})
				.catch(err => {

					this.linkingAccount = false;

					// Display local alert
					this.Alerts.setLocal({
						type: 'danger',
						msg: err.message || err
					});

					// this.$document.scrollTopAnimated(0);
					this.scrollToAlert()

				});

		})
			.catch(err => {

				this.linkingAccount = false;

				// Display local alert
				this.Alerts.setLocal({
					type: 'danger',
					msg: err.message || err
				});

				// this.$document.scrollTopAnimated(0);
				this.scrollToAlert()

			});

	}

}



// WEBPACK FOOTER //
// ./src/app/components/add-bank-account/add-bank-account.controller.js